import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';

export interface Props {
  text: string;
  variant: 'purple-outline' | 'danger';
  iconRight?: boolean;
  iconLeft?: boolean;
  iconSize?: 'xs' | 'sm' | 'lg';
  icon?: IconDefinition;
  className?: string;
  onClick?: (e?: any) => void;
  disabled?: boolean;
  type?: 'submit' | 'button';
  name?: 'primary' | 'warning';
  id?: string;
  children?: React.ReactNode;
}

const WorkflowNavigationButton = ({
  text,
  iconRight,
  iconLeft,
  iconSize = 'sm',
  icon,
  variant,
  className,
  onClick,
  disabled = false,
  type = 'submit',
  name = 'primary',
  id,
  children,
}: Props) => {
  return (
    <Button
      id={id ? id : `${text.replaceAll(' ', '-').toLowerCase()}-button`}
      className={`${className} btn-${variant} d-inline-flex align-items-center gap-2 rounded-pill px-3 px-sm-4 my-1 fw-bold`}
      size="sm"
      type={type}
      onClick={onClick}
      disabled={disabled}
      name={name}
    >
      {icon && iconLeft && (
        <FontAwesomeIcon
          size={iconSize}
          icon={icon}
        />
      )}
      <span className="flex-grow-1 px-1">{text}</span>
      {children}
      {icon && iconRight && (
        <FontAwesomeIcon
          size="xs"
          icon={icon}
        />
      )}
    </Button>
  );
};

export default WorkflowNavigationButton;
